import { COLORS } from '@/constants';
import { Box } from '@mui/material';
import styled from 'styled-components';

export const ScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SearchRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const BrokerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

export const BrokerCard = styled(Box)`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  border: 1px solid ${COLORS['neutral/300']};
  border-radius: 8px;
  background: ${COLORS['white']};
`;

export const BrokerAvatar = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: ${COLORS['primary/200']};
  color: ${COLORS['primary/900']};
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const BrokerInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const EmptyState = styled.div`
  padding: 48px 0;
  text-align: center;
  color: ${COLORS['neutral/500']};
`;
